let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a3INn")).then(() => parcelRequire('01aMQ'));